module.exports = __webpack_public_path__ + "img/undraw_blank_canvas_3rbb.3d5d40c.svg";